import * as fromDatatype from '../datatype-library/index';

export interface bl_applet_plugin_pricing_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface,
    module_guid: fromDatatype.GuidDataFieldInterface,
    applet_guid: fromDatatype.GuidDataFieldInterface,
    plugin_code: fromDatatype.VarcharDatatypeInterface,
    plugin_name: fromDatatype.VarcharDatatypeInterface,
    fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface,
    country_code: fromDatatype.VarcharDatatypeInterface,
    currency_code: fromDatatype.CurrencyCodeDataFieldInterface,
    uom: fromDatatype.VarcharDatatypeInterface,
    unit_price_incl_tax_decimal: fromDatatype.MoneyDatatypeInterface,
    property_json: fromDatatype.JsonDatatypeInterface,
    status: fromDatatype.StatusDataFieldInterface,
    vrsn: fromDatatype.VrsnDataFieldInterface,
    created_date: fromDatatype.TimestampTzDatatypeInterface,
    updated_date: fromDatatype.TimestampTzDatatypeInterface,
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface,
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface,
}

export class bl_applet_plugin_pricing_hdr_RowClass implements bl_applet_plugin_pricing_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface; 
    applet_guid: fromDatatype.GuidDataFieldInterface;
    plugin_code: fromDatatype.VarcharDatatypeInterface;
    plugin_name: fromDatatype.VarcharDatatypeInterface;
    fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    country_code: fromDatatype.VarcharDatatypeInterface;
    currency_code: fromDatatype.CurrencyCodeDataFieldInterface;
    uom: fromDatatype.VarcharDatatypeInterface;
    unit_price_incl_tax_decimal: fromDatatype.MoneyDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}